import { render, staticRenderFns } from "./instance-item-installation-illustration-pending.vue?vue&type=template&id=21616548&scoped=true"
import script from "./instance-item-installation-illustration-pending.vue?vue&type=script&lang=js"
export * from "./instance-item-installation-illustration-pending.vue?vue&type=script&lang=js"
import style0 from "./instance-item-installation-illustration-pending.vue?vue&type=style&index=0&id=21616548&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21616548",
  null
  
)

export default component.exports